import { createContext, useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import http from 'utils/axiosService';
import { domain } from 'config';

// Optional modules switched on/off by the backend's "Features" config section (see Features/FeatureFlags.cs).
// Flags are off until loaded, so disabled modules never flash into view.
export const FEATURES = {
  CleanRoom: 'CleanRoom'
};

const FeatureContext = createContext({ isLoading: true, flags: {} });

export const FeatureProvider = ({ children }) => {
  const [state, setState] = useState({ isLoading: true, flags: {} });

  useEffect(() => {
    http
      .get(`${domain}/api/public/features`)
      .then((res) => setState({ isLoading: false, flags: res.data ?? {} }))
      .catch((error) => {
        console.error('Failed to load feature flags', error);
        setState({ isLoading: false, flags: {} });
      });
  }, []);

  return <FeatureContext.Provider value={state}>{children}</FeatureContext.Provider>;
};

export const useFeatures = () => useContext(FeatureContext);

export const useFeature = (feature) => !!useContext(FeatureContext).flags[feature];

// Route guard: renders children only when the feature is enabled, otherwise redirects home.
export const FeatureRoute = ({ feature, children }) => {
  const { isLoading, flags } = useFeatures();
  if (isLoading) return null;
  return flags[feature] ? children : <Navigate to="/" replace />;
};
